import { createCustomEvent } from "../../../../../javascript/shared/helpers";

export default class extends Controller {

  connect() {
    App.Helpers.addModalHandlers(this.element);
    App.Helpers.addAjaxHandlers(this.element, this.emitSuccessEvent.bind(this), this.emitFailureEvent.bind(this));
  }

  closeForm() {
    document.dispatchEvent(createCustomEvent("form-cancel", this.element));
  }

  emitSuccessEvent() {
    document.dispatchEvent(createCustomEvent("update-success", this.element));
  }

  emitFailureEvent() {
    document.dispatchEvent(createCustomEvent("update-failure", this.element));
  }
};



// WEBPACK FOOTER //
// ./app/components/segmentables/tabs/assets/javascript/segmentables-tabs-nested-associations-form-controller.js